/** Uppercase Azure-safe env segment: A-Z, 0-9, underscore only. */
export const normalizeGraftConfigEnvSegment = (segment: string): string =>
  segment
    .replace(/[^A-Za-z0-9]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '')
    .toUpperCase()
